import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SuccessPage.css';

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="success-page">
      <div className="success-container cancel">
        <div className="cancel-icon">⚠️</div>
        <h1>Paiement Annulé</h1>
        
        <p className="info-text">
          Votre paiement n'a pas été finalisé. Aucun montant n'a été débité de votre compte.
        </p>
        
        <div className="trial-reminder">
          <h3>💡 Rappel</h3>
          <p>Vous pouvez continuer à utiliser l'application gratuitement pendant votre période d'essai de 30 jours.</p>
        </div>
        
        <div className="action-buttons">
          <button 
            className="retry-btn" 
            onClick={() => navigate('/')}
          >
            Réessayer plus tard
          </button>
          <button 
            className="back-link" 
            onClick={() => navigate('/')}
          >
            ← Retour à l'application
          </button>
        </div>
        
        <div className="help-section">
          <h3>🤔 Besoin d'aide ?</h3>
          <ul>
            <li>Vérifiez que votre carte bancaire est valide</li>
            <li>Assurez-vous d'avoir suffisamment de fonds</li>
            <li>Contactez votre banque si le problème persiste</li>
            <li>Essayez avec une autre méthode de paiement</li>
          </ul>
        </div>
        
        <p className="support-text">
          Si vous continuez à rencontrer des difficultés, n'hésitez pas à nous contacter.
        </p>
      </div>
    </div>
  );
};

export default CancelPage; 